import { memo } from "react";
import { Privilege } from "../../services/EmployeeService";
import { useNavigate } from "react-router-dom";
import "./PrivilegeCard.css";

type Props = {
  privilege: Privilege;
};

const PrivilegeCard = ({ privilege }: Props) => {
  const navigate = useNavigate();

  const onClickCardHandler = () => {
    navigate("/privilegeDescription", { state: { privilege } });
  };

  const imageUrl = privilege.image_url || "/placeholder.png";

  return (
    <div className="card" onClick={onClickCardHandler}>
      <div className="card-image">
        <img src={imageUrl} alt={privilege.name || "Privilege"} />
      </div>

      <div className="card-content">
        <p className="card-title">{privilege.name}</p>
      </div>
    </div>
  );
};

export default memo(PrivilegeCard);
